<ngx-slick-carousel
  class="carousel"
  #slickModal="slick-carousel"
  [config]="slideConfig"
>
  <div ngxSlickItem *ngFor="let slide of slides" class="slide">
    <img
      src="{{ slide.img }}"
      loading="lazy"
      alt=""
      width="98%"
      height="300.9px"
    />
  </div>
</ngx-slick-carousel>
